export const errorImgSrc = "../assets/error.png";
